import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AportacionDIPoseedorControllerService } from 'api-rest';
import { SnackbarService } from '../../services/snackbar.service';
import { SpinnerService } from '../../services/spinner.service';

@Component({
  selector: 'app-managers-agreements-contributions-dis-preview-dialog',
  templateUrl: './managers-agreements-contributions-dis-preview-dialog.component.html',
  styleUrls: ['./managers-agreements-contributions-dis-preview-dialog.component.scss'],
})
export class ManagersAgreementsContributionsDisPreviewDialogComponent implements OnInit, OnDestroy {
  fileUrl?: SafeResourceUrl;
  fileType?: string;
  tiposFicheroPermitidos = ['application/pdf', 'text/plain'];

  constructor(
    public dialog: MatDialog,
    public spinnerSrv: SpinnerService,
    private dialogRef: MatDialogRef<ManagersAgreementsContributionsDisPreviewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public aportacion: any,
    private sanitizer: DomSanitizer,
    private snackBarSrv: SnackbarService,
    private aportacionDiService: AportacionDIPoseedorControllerService
  ) {}

  ngOnInit() {
    this.cargarDocumento();
  }

  ngOnDestroy() {
    if (this.fileUrl) {
      URL.revokeObjectURL(this.fileUrl as string);
    }
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  cargarDocumento() {
    this.fileType = this.getMimeType(this.aportacion?.documento?.nombre);
    if (this.tiposFicheroPermitidos.includes(this.fileType!) || this.fileType?.startsWith('image/')) {
      this.spinnerSrv.loadingShow();
      this.aportacionDiService.downloadDoc(this.aportacion?.id, 'response').subscribe({
        next: (response) => {
          const blob = new Blob([response.body!], { type: this.fileType });
          const url = URL.createObjectURL(blob);
          this.fileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
          this.spinnerSrv.loadingHide();
        },
        error: () => {
          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar('Ha ocurrido un error al cargar el documento.', 'error');
        },
      });
    } else {
      this.snackBarSrv.showSnackBar('No se puede previsualizar el archivo.', 'error');
    }
  }

  getMimeType(filename: string): string {
    const ext = filename.split('.').pop()?.toLowerCase();
    switch (ext) {
      case 'pdf':
        return 'application/pdf';
      case 'txt':
        return 'text/plain';
      case 'docx':
        return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
      case 'doc':
        return 'application/msword';
      case 'jpg':
      case 'jpeg':
        return 'image/jpeg';
      case 'png':
        return 'image/png';
      default:
        return 'application/octet-stream';
    }
  }
}
